import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { ISubscriptionInfo, SubscriptionTargetTypes } from '../models/ISubscriptionInfo';
import { Module } from '../Module';
import { Subscriptions } from '../resources/Subscriptions';
import { IResult } from '../ServerApi/types/IResponse';
import { ConfirmActionDialog, IConfirmActionDialogInstance } from './ConfirmActionDialog';
import { ToasterService, ToastType } from './ToasterService';

export interface IChangeSubscriptionSubjectDialogScope extends ng.IScope {
  description: string;
  input: {
    text: string;
    maxLength?: number;
  };
}

export class ChangeSubscriptionSubjectAction {

  public static $inject = ['ConfirmActionDialog', '$translate', 'ToasterService', 'Subscriptions'];

  constructor(
    private ConfirmActionDialog: ConfirmActionDialog,
    private $translate: ng.translate.ITranslateService,
    private toaster: ToasterService,
    private Subscriptions: Subscriptions) { }

  public changeSubject(subscription: ISubscriptionInfo, context: IActionContext): ng.IPromise<IResult> {

    const scope = <IChangeSubscriptionSubjectDialogScope> context.scope.$new();
    scope.description = ''; // This should only be used if the server returns bad data.
    switch (subscription.targetType) {
      case SubscriptionTargetTypes.view:
        scope.description = this.$translate.instant('confirmChangeViewSubscriptionSubject', { VIEW_NAME: L10n.elideIfLong(subscription.targetName) });
        break;
      case SubscriptionTargetTypes.workbook:
        scope.description = this.$translate.instant('confirmChangeWorkbookSubscriptionSubject', { WORKBOOK_NAME: L10n.elideIfLong(subscription.targetName) });
        break;
    }
    scope.input = {
      text: subscription.subject,
      maxLength: 255
    };

    return this.ConfirmActionDialog.open({
      title: this.$translate.instant('changeSubject'),
      bodyTemplateUrl: 'confirmActionDialogInput.html',
      scope: scope,
      actionName: this.$translate.instant('changeSubject'),
      action: (dialogInstance: IConfirmActionDialogInstance) => {

        return this.Subscriptions.changeSubject(subscription.id, scope.input.text).then((result: IResult) => {
          if (result.errors && result.errors.length) {
            dialogInstance.showErrorMessage(
              this.$translate.instant('changeSubjectFailure', {
                SUBJECT: subscription.subject
              }));
          } else {
            this.toaster.pop({
              type: ToastType.Info,
              text: this.$translate.instant('changeSubjectSuccess', {
                SUBJECT: scope.input.text
              }),
              testId: 'change-subscription-subject-success'
            });
            subscription.subject = scope.input.text;
          }
          return result;
        });
      }
    }).result.finally(() => scope.$destroy());
  }

}

Module.instance().service('ChangeSubscriptionSubjectAction', ChangeSubscriptionSubjectAction);
